import { toast } from 'react-toastify';

const shownErrors = new Map(); 
const DEBOUNCE_TIME = 100; 

function showError(message) {
    if (shownErrors.has(message)) {
      const existingTimeout = shownErrors.get(message);
      clearTimeout(existingTimeout);
  
      const timeoutId = setTimeout(() => {
        shownErrors.delete(message);
      }, DEBOUNCE_TIME);
  
      shownErrors.set(message, timeoutId);
      return;
    }
  
    toast.error(message);
  
    const timeoutId = setTimeout(() => {
      shownErrors.delete(message);
    }, DEBOUNCE_TIME);
  
    shownErrors.set(message, timeoutId);
}

const apiError = (error) => {
    if (error && error.response && error.response.status === 440) {
        for (let i = 0; i < error.response.data.errors.length; i++) {
            showError(error.response.data.errors[i]);
        }
        setTimeout(() => {
            window.location = '/login?next=' + window.location.pathname;
        }, 2000);
    } else if (error && error.response && error.response.data && error.response.data.errors) {
        for (let i = 0; i < error.response.data.errors.length; i++) {
            showError(error.response.data.errors[i]);
        }
    } else if (error?.response && error.response.data && error.response.data.isJoi) {
        for (let i = 0; error.response.data.details && i < error.response.data.details.length; i++) {
            showError(error.response.data.details[i].message);
        }
    } else {
        if (navigator.onLine) {
            showError('Something Went Wrong!');
        } else {
            showError('We Are Offline, Please Check Your Internet Connetion !');
        }
    }
}

export default apiError;